var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 106,
    viewBox: "0 0 99 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_925_5232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0026 37.2774L7.68507 41.0931L7.21894 41.1879C6.51332 41.3753 5.87005 41.7465 5.35482 42.2637C4.8396 42.781 4.47088 43.4257 4.28633 44.132C4.10177 44.8384 4.10798 45.5811 4.30433 46.2843C4.50068 46.9874 4.88014 47.6259 5.40394 48.1344L24.4697 66.6928L19.9734 92.9072L19.9198 93.3609C19.8766 94.0907 20.0282 94.8189 20.3589 95.4709C20.6897 96.1229 21.1878 96.6752 21.8022 97.0714C22.4166 97.4676 23.1253 97.6934 23.8557 97.7256C24.5861 97.7579 25.3119 97.5954 25.9588 97.2549L49.4961 84.8799L72.9797 97.2549L73.3922 97.4447C74.0731 97.7129 74.813 97.7951 75.5362 97.6829C76.2593 97.5708 76.9396 97.2682 77.5073 96.8064C78.0749 96.3446 78.5095 95.74 78.7664 95.0548C79.0233 94.3696 79.0933 93.6284 78.9692 92.9072L74.4688 66.6928L93.5428 48.1303L93.8646 47.7797C94.3242 47.2136 94.6255 46.5358 94.7379 45.8153C94.8503 45.0949 94.7697 44.3575 94.5043 43.6783C94.2389 42.9991 93.7983 42.4025 93.2272 41.949C92.6561 41.4956 91.9751 41.2017 91.2534 41.0972L64.9359 37.2774L53.1714 13.4349C52.831 12.7441 52.304 12.1624 51.6501 11.7557C50.9962 11.3489 50.2414 11.1333 49.4713 11.1333C48.7012 11.1333 47.9465 11.3489 47.2925 11.7557C46.6386 12.1624 46.1116 12.7441 45.7712 13.4349L34.0026 37.2774Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_925_5232",
    x: 0.152344,
    y: 11.1333,
    width: 98.6367,
    height: 94.5981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_925_5232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_925_5232",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/starWhite.301f2a66f8f9f6b412889661a235d283.svg";
export { ForwardRef as ReactComponent };